import { Component, OnInit, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { OAuthService } from 'angular-oauth2-oidc';
import { CookieService } from 'ngx-cookie-service';
import { environment } from '../../environments/environment';
import { RegistrationRoutingService } from '../services/registration-routing.service';

@Component({
  selector: 'app-login',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.css']
})
export class LoginComponent implements OnInit {
  appTypeParam: string = '';


  private oauthService = inject(OAuthService);
  private cookieService = inject(CookieService);
  private registrationRouting = inject(RegistrationRoutingService);
 
  ngOnInit() {
    this.clearSession();

    const queryParams = this.registrationRouting.queryStringParams();
    if (queryParams) {
      localStorage.setItem('UtmParams', queryParams);
      const urlParams = new URLSearchParams(queryParams.toLowerCase());
      this.appTypeParam = urlParams.get('appType') || '';
      if (this.appTypeParam === 'android') {
        sessionStorage.setItem('isGoogleApk', 'true');
        localStorage.setItem('isApk', 'true');
      }
    }
    sessionStorage.setItem('isRedirected', JSON.stringify(true));
    
    this.oauthService.loadDiscoveryDocument().then(() => {
  this.azureAdlogin();
});
  }
 
  azureAdlogin() {
    const submissionId = sessionStorage.getItem('submissionId') || '';

    const loginCallback = () => {
      const pageLoadTimestamp = Date.now();
      const trackingVisitorId = this.cookieService.get('visitorId') || '';
      const trackingSessionId = sessionStorage.getItem('sessionId') || '';
      console.log('trackingVisitorId', trackingVisitorId);
      console.log('trackingSessionId', trackingSessionId);
      if (this.oauthService.loginUrl && this.oauthService.loginUrl.includes('authorize')) {
        this.oauthService.initLoginFlow('', {
          submissionId,
          ccAppUrl: window.location.origin,
          instrumentationKey: environment.appInsights.instrumentationKey,
          trackingVisitorId,
          trackingSessionId,
          ...(this.appTypeParam ? { appType: this.appTypeParam } : {}),
          loginTime: pageLoadTimestamp
        });
      } else {
        setTimeout(() => loginCallback(), 1000);
      }
    };
    loginCallback();
  }
  clearSession(){
   
    this.cookieService.delete('submissionId', '/');
    this.cookieService.delete('uType', '/');
    this.cookieService.delete('userId', '/');
    this.cookieService.delete('authToken', '/');
    localStorage.removeItem('isLoginSuccess');
    sessionStorage.removeItem('isRedirected');
    localStorage.removeItem('access_token');
    localStorage.removeItem('access_token_stored_at');
    localStorage.removeItem('expires_at');
  }
}
